export default __webpack_public_path__ + "static/media/plusik.0438a8bc.svg";